import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '@shared/ui/card';
import { Button } from '@shared/ui/button';
import { FileText, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useConsumerBill } from '../../../shared/hook';
import { getLoginDataFromStorage } from '@shared/utils/loginUtils';
import { getRemoteUtilityId } from '@shared/utils/getUtilityId';
import { useCurrency } from '@shared/selectors/globalSelectors';
import { useTranslation } from 'react-i18next';

export const RecentBillsWidget = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { remoteConsumerNumber } = getLoginDataFromStorage();
  const currency = useCurrency();

  const { data: billsData } = useConsumerBill({
    remote_utility_id: getRemoteUtilityId(),
    consumer_number: remoteConsumerNumber,
    is_pagination_required: true,
    is_bill_summary: true
  });

  const recentBills = billsData?.result?.results || billsData?.results || billsData?.result || [];

  return (
    <Card className="rounded-2xl shadow-sm border-slate-200 h-full flex flex-col">
      <CardHeader className="flex flex-row items-center justify-between pb-2">
        <CardTitle className="text-lg font-bold text-slate-800">{t("Recent Bills")}</CardTitle>
        <Button variant="ghost" size="sm" className="text-blue-600 font-semibold h-8 px-2" onClick={()=>navigate("/dashboard/billing")}>{t("View All")} <ArrowRight size={16} className="ml-1" /></Button>
      </CardHeader>
      <CardContent className="flex-1 flex flex-col gap-3">
        {recentBills.slice(0, 3).map((bill: any, idx: number) => (
          <div key={idx} className="flex items-center justify-between p-3 rounded-xl border border-slate-100 hover:bg-slate-50 transition-colors">
            <div className="flex items-center gap-3">
              <div className="p-2 rounded-lg bg-blue-50 text-blue-600">
                <FileText size={20} />
              </div>
              <div>
                <p className="text-sm font-bold text-slate-800">{currency} {Number(bill.totalAmountPayable || bill.amount || 0).toFixed(2)}</p>
                <p className="text-xs font-medium text-slate-500">{bill.createdDate || bill.date || 'N/A'} • {bill.invoiceNo || bill.id || 'N/A'}</p>
              </div>
            </div>
            <span className={`text-[10px] font-bold uppercase tracking-wider px-2 py-1 rounded-full ${(bill.paymentStatus || bill.status) === 'Paid' ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'}`}>
              {(bill.paymentStatus || bill.status) === 'Paid' ? t("Paid") : t("Unpaid")}
            </span>
          </div>
        ))}
        {recentBills.length === 0 && (
          <div className="flex-1 flex items-center justify-center text-sm text-slate-500">{t("No recent bills")}</div>
        )}
      </CardContent>
    </Card>
  );
};
